import axiosInstance from "../lib/axios";

interface GetInvoiceRequest {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
}

export interface InvoiceItemRequest {
  description: string;
  qty: number;
  unit: string;
  price: number;
  // Optional link to the product catalog for this line item.
  product_id?: number | null;
}

export interface CreateInvoiceRequest {
 
  totalPaymentDue: string;
  sales_id: number | null; // sebelumnya sales_name (text bebas)
  po_number?: string;
  customer_id?: string;

  // Optional link to an existing customer record (separate from the legacy
  // free-text customer_id above, matches backend's customer_id_ref column).
  customer_id_ref?: number | null;

  delivery_time: string;
  place_of_delivery: string;

  invoice_date: string;
  due_date?: string;

  discount: number;
  ppn: number;

  invoice_status_id: number;

  items: InvoiceItemRequest[];
}



export const getInvoice = async ({ page = 1, limit = 10, search, status, }: GetInvoiceRequest) => {
  const body = { page, limit, search, status, };

  const { data } = await axiosInstance.post("/Invoice/List", body);

  return data;
};

export const createInvoice = (data: CreateInvoiceRequest) => {
  return axiosInstance.post("/Invoice/Create", data);
};

export const getInvoiceById = (id: number) => {
  return axiosInstance.get(`/Invoice/${id}`);
};

export const editInvoice = (id: number, data: CreateInvoiceRequest) => {
  return axiosInstance.put(`/Invoice/${id}`, data);
};

export const deleteInvoiceById = (id: number) => {
  return axiosInstance.delete(`/Invoice/${id}`);
};

// Endpoint PDF invoice belum tersedia di backend - tambahkan setelah
// generateInvoiceHtml.ts & route /:id/pdf dibuat (menyusul setelah CRUD ini).
export const invoicePdf = (id: number) => {
  return axiosInstance.post(`/Invoice/${id}/pdf`, null, {
    responseType: "blob",
  });
};


export const getInvoiceStatus = async () => {
  const { data } = await axiosInstance.get("/Invoice/invoice-status");


  return data;
};

export const editStatusinvoice = (id: number, data: any) => {
  return axiosInstance.put(`/Invoice/updateStatus/${id}`, data);
};